import { Briefcase, FileText, Users, Building, ExternalLink, GraduationCap, DollarSign } from "lucide-react";

const CAREER_LINKS = [
  { name: "LinkedIn", icon: Users, url: "https://www.linkedin.com", color: "bg-blue-700" },
  { name: "Indeed", icon: Briefcase, url: "https://www.indeed.com", color: "bg-blue-600" },
  { name: "Glassdoor", icon: Building, url: "https://www.glassdoor.com", color: "bg-green-600" },
  { name: "Monster", icon: Briefcase, url: "https://www.monster.com", color: "bg-purple-600" },
  { name: "ZipRecruiter", icon: Briefcase, url: "https://www.ziprecruiter.com", color: "bg-green-700" },
  { name: "CareerBuilder", icon: Building, url: "https://www.careerbuilder.com", color: "bg-blue-500" },
  { name: "Resume.io", icon: FileText, url: "https://resume.io", color: "bg-indigo-600" },
  { name: "Canva Resume", icon: FileText, url: "https://www.canva.com/resumes/", color: "bg-cyan-600" },
  { name: "Zety Resume", icon: FileText, url: "https://zety.com", color: "bg-teal-600" },
  { name: "Coursera", icon: GraduationCap, url: "https://www.coursera.org", color: "bg-blue-800" },
  { name: "Udemy", icon: GraduationCap, url: "https://www.udemy.com", color: "bg-purple-700" },
  { name: "Salary.com", icon: DollarSign, url: "https://www.salary.com", color: "bg-green-500" },
  { name: "PayScale", icon: DollarSign, url: "https://www.payscale.com", color: "bg-orange-600" },
  { name: "Remote OK", icon: Building, url: "https://remoteok.com", color: "bg-yellow-600" },
];

const CareerWorkPanel = ({ roomId }) => {
  if (roomId !== "career-work") return null;

  const openLink = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="retro-window mb-2" data-testid="career-work-panel">
      <div className="retro-title-bar px-2 py-1">
        <span className="flex items-center gap-1">
          <Briefcase className="w-4 h-4" />
          💼 CAREER TOOLS
        </span>
      </div>

      <div className="p-2 bg-gradient-to-b from-gray-100 to-gray-200 max-h-[300px] overflow-y-auto retro-scrollbar">
        <div className="space-y-1">
          {CAREER_LINKS.map((link, index) => {
            const Icon = link.icon;
            return (
              <button
                key={index}
                className={`${link.color} hover:opacity-90 text-white rounded w-full p-1.5 transition-all flex items-center gap-2 text-xs`}
                onClick={() => openLink(link.url)}
              >
                <Icon className="w-4 h-4 flex-shrink-0" />
                <span className="font-bold truncate">{link.name}</span>
                <ExternalLink className="w-3 h-3 ml-auto flex-shrink-0 opacity-70" />
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default CareerWorkPanel;
